function getInitialProducts(container) {
    // get the available products in the bundle
    const availableProducts = container.querySelector('.bndlr-mnm-available-products');
    if (!availableProducts) return; // already removed
    // get the required products from the available products
    const requiredProducts = Array.from(availableProducts.querySelectorAll('.bndlr-product')).filter(
        (product) => product.getAttribute('data-mnm-required') === 'true'
    );
    // get the IDs of the required products
    const requiredProductIDs = requiredProducts.map(product => product.getAttribute("data-product-id"));

    return {
        availableProducts, requiredProducts, requiredProductIDs
    }
}

function addPricesToSelectedProducts(availableProducts, selectedProducts) {
    const prices = Array.from(availableProducts.children).map(product => ({
        product_id: product.getAttribute("data-product-id"),
        price: product.querySelector(".bndlr-new-price").getAttribute("data-currency-usd")
    }));
    // add price to selected products
    prices.forEach(({ product_id, price }) => {
        const product = Array.from(selectedProducts.children).filter(product => product.querySelector(`.id_${product_id}`))[0];
        const priceElement = document.createElement('div');
        priceElement.classList = `bundlr-product-price id_${price}`;
        priceElement.innerHTML = `<span class="bndlr-new-price bndlr-money conversion-bear-money notranslate ht-money  money  gt_currency gt_currency--usd" aria-label="Current price" data-money-convertible="" data-currency-usd="${price}"><span class="sr-only bndlr-sr-only">Current price: </span>${price}</span>`;
        if (!product?.querySelector('.bundlr-product-price')) {
            product?.appendChild(priceElement);
        }
    });
}

function removeCloseFromRequiredProducts(selectedProducts, requiredProductIDs) {
    Array.from(selectedProducts.children).forEach(product => {
        if (requiredProductIDs.includes(product.getAttribute("data-variant-id"))) {
            product.querySelector(".bndlr-close").remove();
        }
    })
}

document.addEventListener('bundler:mixnmatch:product_added', function(e) {
    const containers = document.querySelectorAll('.bndlr-container');

    containers.forEach(container => {
        const result = getInitialProducts(container);
        if (!result) return;

        const { availableProducts, requiredProductIDs } = result;
        const selectedProducts = container.querySelector('.bndlr-mnm-selected-products');

        addPricesToSelectedProducts(availableProducts, selectedProducts);

        if (availableProducts.children.length === selectedProducts.children.length) {
            availableProducts.remove();
            return;
        }

        removeCloseFromRequiredProducts(selectedProducts, requiredProductIDs);
    });
});

document.addEventListener('bundler:bundle_widget_created', function(e) {
    const containers = document.querySelectorAll('.bndlr-container');

    containers.forEach(container => {
        const { availableProducts, requiredProducts, requiredProductIDs } = getInitialProducts(container);
        // automatically add the required products to the bundle
        requiredProducts.forEach((product) => product.querySelector('.bndlr-add-to-bundle')?.click());
        // remove the delete button from pre-selected products
        container.querySelectorAll(".bndlr-close").forEach(el => el.remove());

        // Select the node that will be observed for mutations
        const targetNode = container.querySelector('.bndlr-mnm-instructions-text');

        // Options for the observer (which mutations to observe)
        const config = { childList: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            const mutation = mutationList.filter(m => m.type === 'childList')[0];
            if (!mutation) return;

            const { availableProducts, requiredProductIDs } = getInitialProducts(container);
            const selectedProducts = container.querySelector('.bndlr-mnm-selected-products');

            addPricesToSelectedProducts(availableProducts, selectedProducts);
            removeCloseFromRequiredProducts(selectedProducts, requiredProductIDs);
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    });
}, { once: true });
